import { render, staticRenderFns } from "./transportForm.vue?vue&type=template&id=72a5018b&scoped=true&"
import script from "./transportForm.vue?vue&type=script&lang=js&"
export * from "./transportForm.vue?vue&type=script&lang=js&"
import style0 from "./transportForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./transportForm.vue?vue&type=style&index=1&id=72a5018b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5018b",
  null
  
)

export default component.exports